import { render } from "./UserAnalytics.vue?vue&type=template&id=1e56ddaa"
import script from "./UserAnalytics.vue?vue&type=script&lang=js"
export * from "./UserAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__